import React,{useEffect, useState} from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import BarcodeScanner from 'react-qr-barcode-scanner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faCheck, faCheckCircle, faFaceFrown, faFaceSmile } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@progress/kendo-react-buttons';

export const GateCount=({onClose, areaId})=>{
    const [scanValue,setScanValue]=useState("");    
    const [showScanner,setShowScanner]=useState(true);
    const [age,setAge]=useState(0);
    const [className,setClassName]=useState("ageReport")


    //Record a participant's entry into the program area.
    
    const gateScan=()=>{
        console.log("Gate Scan: " + areaId + " " + scanValue);
        const postData = new FormData();
        const url= "api/index.php/program/gateScan";
        postData.append("id",scanValue);
        postData.append("area",areaId);
        fetch (url,{
            method:"POST",
            body:postData
        }).then(response=>response.json()).then(async data=> {
            console.log(data);
        })
    }

    const onScan=(err,result)=>{
        if (result){
            console.log(result);
            setScanValue(result.text);
            hideScanner();
        }
    }

    const openScanner=()=>{
        setScanValue("");
    }
    const hideScanner=()=>{
        setShowScanner(false);
    }

    useEffect(()=>{
        console.log("ScanValue:" + scanValue);
        if (scanValue!==""){
            gateScan();
        }else{
            setShowScanner(true);
        }
    },[scanValue]);


    return(
        <Dialog title="Gate Check" onClose={onClose} width={"90vw"} height={"80vh"}>
            {scanValue!=""?
                <div className='scanResult go' >
                    <div style={{fontSize:"xxx-Large"}}><FontAwesomeIcon icon={faFaceSmile} /></div>
                    <h1>{scanValue}</h1>
                    <div style={{fontSize:"xxx-Large", padding:"10px"}}><FontAwesomeIcon icon={faCheck} /></div>
                    <Button size='large' fillMode='outline' style={{color:"white"}} onClick={gateScan}>Scan Again</Button>
                </div>
            :null}
            {showScanner?
            <>
                <div style={{fontSize:"xxx-Large", textAlign:"center"}}><FontAwesomeIcon icon={faCamera} /></div>
                <p>Use the device camera to scan the barcode found on the Jamboree ID.</p>
                <BarcodeScanner width={"90%"} onUpdate={onScan}></BarcodeScanner>
            </>
            :null}
        </Dialog>
    )

}